import React, { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Autocomplete, Box, Button, TextField } from '@mui/material';
import { Organization } from 'models/organization';
import { useQuery } from '@apollo/client';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';
import { AddTransportContext } from 'pages/transport/add-transport/add-transport-context';
import { getLabsTemplate } from 'apollo/templates/user/query.graphql';

type TransportLabStepProps = {
    onNavigateNext: () => void;
};
const TransportLabStep: FC<TransportLabStepProps> = ({ onNavigateNext }: TransportLabStepProps) => {
    const { t: translate } = useTranslation(['common', 'transport']);
    const { transportOrderReq, setTransportOrderReq } = useContext(AddTransportContext);
    const { showBoundary } = useDenthubErrorBoundary();

    const { data: { labs } = {}, loading } = useQuery(getLabsTemplate, {
        variables: {
            isTransportEnable: true,
        },
        onError(error) {
            showBoundary(error);
        },
    });

    return (
        <Box>
            <Box mb={4}>
                <Autocomplete
                    loading={loading}
                    options={labs || []}
                    onChange={(_, lab) => setTransportOrderReq({ ...{ ...transportOrderReq, lab: lab, date: null } })}
                    value={transportOrderReq.lab}
                    getOptionLabel={(option: Organization) => option?.name || ''}
                    isOptionEqualToValue={(option: Organization, value: Organization) => option?._id === value?._id}
                    renderInput={(params) => <TextField {...params} label={translate('common:LAB')} fullWidth={true} />}
                />
            </Box>
            <Box display="flex" justifyContent="flex-end">
                <Button variant="contained" onClick={onNavigateNext} disabled={!transportOrderReq.lab}>
                    {translate('common:NEXT_STEP')}
                </Button>
            </Box>
        </Box>
    );
};

export default TransportLabStep;
